<template>
  <div>
    <main-banner v-bind:image="'src/assets/images/' + image"></main-banner>
    <h2 class="blue--text mt-5">{{ $t('pages.clients.pharmacies.title') }}</h2>
    <div class="mt-2 section-content" v-html="$t('pages.clients.pharmacies.about')"></div>
    <h2 class="blue--text mt-5">{{ $t('pages.clients.pharmacies.products.title') }}</h2>
    <div class="mt-2 section-content" v-html="$t('pages.clients.pharmacies.products.content')"></div>
    <v-layout class="row wrap mt-5">
      <v-flex v-for="item in products" :key="item" xs12 lg6 class="pa-3">
        <v-card>
          <v-card-title primary-title v-bind:class="'white--text blue darken-' + (index + 1)">
            <div>
              <div class="headline">{{ $t('pages.clients.pharmacies.products.items.' + item.name + '.name') }}</div>
            </div>
          </v-card-title>
          <v-card-text class="text-xs-center">
            <video width="90%" height="auto" controls>
              <source v-bind:src="'src/assets/video/' + item.video" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </v-card-text>
          <v-card-row class="blue lighten-1">
            <v-card-text>
              <span
                  class="white--text">{{ $t('pages.clients.pharmacies.products.items.' + item.name + '.description') }}</span>
            </v-card-text>
          </v-card-row>
        </v-card>
      </v-flex>
    </v-layout>
    <h2 class="blue--text mt-5">{{ $t('pages.clients.pharmacies.cooperation.title') }}</h2>
    <div class="mt-2 section-content">
      <div v-html="$t('pages.clients.pharmacies.cooperation.content')"></div>
      <div><strong>{{ $t('pages.clients.pharmacies.cooperation.voivodships') }}</strong></div>
      <v-layout class="row wrap">
        <v-flex xs12 lg8 offset-lg2>
          <v-layout class="row wrap mt-2">
            <v-flex v-for="item in reps" :key="item" xs12 lg6>
              <div><strong>{{ item.name }}</strong></div>
              <div>{{ item.phone }}</div>
              <br>
              <div v-for="voivodship in item.voivodships" :key="voivodship">
                {{ voivodship }}
              </div>
              <br>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div v-html="$t('pages.clients.pharmacies.cooperation.contact')"></div>
      <div>
        <v-btn block href="/download/raportownik.zip">
          {{ $t('pages.clients.pharmacies.cooperation.raportownik') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import MainBanner from '../sections/MainBanner.vue'

export default {
  name: 'pharmacies',
  components: {
    'main-banner': MainBanner
  },
  data() {
    return {
      image: 'pharmacies.jpg',
      products: [
        {
          id: 1,
          name: 'cia',
          video: 'CIA.mp4'
        },
        {
          id: 2,
          name: 'psa',
          video: 'PSA.mp4'
        }
      ],
      reps: [
        {
          name: "Bogdan Kogut",
          phone: "+48 502 288 517",
          voivodships: [
            "Dolnośląskie",
            "Kujawsko-Pomorskie",
            "Łódzkie",
            "Lubuskie",
            "Opolskie",
            "Pomorskie",
            "Wielkopolskie",
            "Zachodniopomorskie"
          ]
        },
        {
          name: "Grzegorz Ciemięga – Wilczyński",
          phone: "+48 601 951 798",
          voivodships: [
            "Lubelskie",
            "Mazowieckie",
            "Małopolskie",
            "Podkarpackie",
            "Podlaskie",
            "Śląskie",
            "Świętokrzyskie",
            "Warmińsko-Mazurskie",
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// Pharmacies.vue?0cab5292